import styled, { css, FlattenSimpleInterpolation } from 'styled-components';

import { BoxShadow, Color, FontWeight, TextBoxTheme } from '../../enums';
import { StyledComponent } from '../../interfaces';
import { hexToRgba } from '../../utils';
import { Markdown } from '../markdown/markdown.component';

import { ButtonProps, ContainerProps, ContentProps } from './textBox.types';

const TextBoxStyles: { [b in TextBoxTheme]: FlattenSimpleInterpolation } = {
  [TextBoxTheme.White]: css`
    background-color: ${Color.White};
    box-shadow: ${BoxShadow.BackgroundShadow};
  `,
  [TextBoxTheme.Transparent]: css`
    background-color: ${hexToRgba(Color.Black, 0.25)};
  `,
  [TextBoxTheme.Orange]: css`
    background-color: ${Color.Error500};
    box-shadow: ${BoxShadow.BackgroundShadow};
  `,
};

export const Container: StyledComponent<'div', ContainerProps> = styled.div<ContainerProps>`
  max-width: 340px;
  width: 100%;
  padding: 20px;
  border-radius: 4px;
  ${({ $theme }: ContainerProps): FlattenSimpleInterpolation => TextBoxStyles[$theme]};
`;

export const Content: StyledComponent<typeof Markdown, ContentProps> = styled(Markdown)<ContentProps>`
  font-size: 14px;
  line-height: 18px;
  color: ${({ $theme }: ContentProps): string => $theme === TextBoxTheme.White ? Color.Black : Color.White};

  a {
    color: ${({ $theme }: ContentProps): string => $theme === TextBoxTheme.White ? Color.Black : Color.White};
  }
`;

export const Button: StyledComponent<'button', ButtonProps> = styled.button.attrs<ButtonProps>({ type: 'button' })`
  color: ${({ $theme }: ButtonProps): string => $theme === TextBoxTheme.White ? Color.Black : Color.White};
  font-size: 14px;
  line-height: 18px;
  font-weight: ${FontWeight.Medium};
  text-decoration: underline;
  margin-top: 12px;
`;
